import React, { useState, useEffect } from 'react';
import { Modal, Button, Input, Alert } from '@/modules/ui/components';

function OpponentNameModal({ isOpen, onClose, onConfirm, error = null, isSaving = false }) {
  const [opponentName, setOpponentName] = useState('');

  // Initialize with stored opponent name when modal opens; clear when closed
  // so a previous attempt's name never leaks into the next match.
  useEffect(() => {
    if (isOpen) {
      const storedOpponentName = localStorage.getItem('opponent_name');
      if (storedOpponentName && storedOpponentName.trim()) {
        setOpponentName(storedOpponentName.trim());
      }
    } else {
      setOpponentName('');
    }
  }, [isOpen]);

  const handleClose = () => {
    setOpponentName('');
    onClose();
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    if (opponentName.trim() && !isSaving) {
      onConfirm(opponentName.trim());
    }
  };

  // Get stored opponent name for placeholder
  const storedOpponentName = localStorage.getItem('opponent_name');
  const placeholderText = storedOpponentName && storedOpponentName.trim() 
    ? storedOpponentName.trim()
    : 'Enter opponent team name';

  return (
    <Modal isOpen={isOpen} onClose={handleClose} title="Save Match Data">
      <div className="p-6">
        <p className="text-gray-600 dark:text-gray-400 mb-6">
          {storedOpponentName && storedOpponentName.trim()
            ? 'Confirm or update the opponent team name to save this match to your history.'
            : 'Enter the opponent team name to save this match to your history.'
          }
        </p>

        <form onSubmit={handleSubmit}>
          {error && (
            <div className="mb-6">
              <Alert variant="error">{error}</Alert>
            </div>
          )}
          <div className="mb-6">
            <Input
              id="opponentName"
              label="Opponent Team Name"
              type="text"
              value={opponentName}
              onChange={(e) => setOpponentName(e.target.value)}
              placeholder={placeholderText}
              required
              autoFocus
            />
          </div>

          <div className="space-y-3 sm:space-y-0 sm:flex sm:space-x-3">
            <Button
              type="submit"
              variant="primary"
              disabled={!opponentName.trim() || isSaving}
              loading={isSaving}
              fullWidth
              className="cursor-pointer"
            >
              {isSaving ? 'Saving...' : 'Save Match'}
            </Button>
            <Button
              type="button"
              variant="secondary"
              onClick={handleClose}
              fullWidth
              className="cursor-pointer"
            >
              Skip
            </Button>
          </div>
        </form>
      </div>
    </Modal>
  );
}

export default OpponentNameModal;